import { useCalendarSettings } from '@/schedule/composables/useCalendarSettings'

const dayjs = useDayjs()
const { calendar_timezone_display_mode } = useCalendarSettings()

function formatTimeZoneOffset(offset) {
  let sign = '+'
  if (offset[0] === '-') {
    sign = '-'
    offset = offset.slice(1)
  }
  const [hour, fractionalHour] = offset.split('.')
  const paddedHour = hour.padStart(2, '0')
  const paddedMinutes = (+(fractionalHour || 0) / 10 * 60).toString().padStart(2, '0')

  const result = `${sign}${paddedHour}:${paddedMinutes}`

  return result
}

function getLocalTimezoneDateString(date) {
  return dayjs.value(new Date(date)).format('YYYY-MM-DDTHH:mm:ss')
}

export function useTimeZone() {
  const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const browserTimeZoneOffset = (new Date()).getTimezoneOffset() / -60
  const shouldConvertTimeZone = calendar_timezone_display_mode === 'customer'
  const formattedBrowserTimeZoneOffset = formatTimeZoneOffset(browserTimeZoneOffset.toString())
  const convertDateTimeForDisplay = (date) => {
    if (shouldConvertTimeZone)
      return getLocalTimezoneDateString(date)
    return date.slice(0, 19)
  }

  return {
    browserTimeZone,
    browserTimeZoneOffset,
    formattedBrowserTimeZoneOffset,
    convertDateTimeForDisplay,
    shouldConvertTimeZone,
  }
}
